module.exports = __webpack_public_path__ + "media/react/marketing/pages/plans/sections/offers/assets/checkmark_icon-c1e0349cab0b4094697a8cd83771f29a.svg";